<template>
    <div class="dialog-section service-fee-statement-info-section">
        <div v-if="!noHeader" class="dialog-section-title">
            <div class="service-fee-statement-title-block">
                <div>
                    <span>勞報單 </span>
                    <span v-if="serviceFeeStatementList.length > 0">({{ serviceFeeStatementList.length }})</span>
                    <span v-if="serviceFeeStatementList.length === 0">(無)</span>
                </div>
                <el-dropdown v-if="!disabled && !isQR()" @command="onAttachServiceFeeStatements">
                    <el-button size="mini">
                        <i class="el-icon-more"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>附加勞報單</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div v-if="serviceFeeStatementList.length > 0 ? true : isShowEmptyTable">
            <el-table
                v-loading="isLoading"
                :data="serviceFeeStatementList"
                ref="table"
                empty-text="無資料"
                style="width: 100%"
                class="payment-detail-service-fee-statement-table"
                show-summary
                :summary-method="getTableSummaries"
                @row-click="onRowClick"
            >
                <el-table-column type="index" width="45"> </el-table-column>
                <el-table-column prop="systemNo" label="系統單號" width="100"></el-table-column>
                <el-table-column prop="status" label="狀態" width="100">
                    <template slot-scope="scope">
                        <StatusLabel :statusNum="scope.row.status" />
                    </template>
                </el-table-column>
                <el-table-column prop="nam" label="勞報單摘要">
                    <template slot-scope="scope"> <span v-if="scope.row.isAttached" class="is-attached">補送</span>{{ scope.row.nam }} </template>
                </el-table-column>
                <el-table-column prop="incomeServiceType" label="所得類別/業別代號" width="180">
                    <template slot-scope="scope">
                        <span>{{ getIncomeType(scope.row.incomeType) }} {{ getServiceType(scope.row.serviceType) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amt" label="應付金額" align="right" width="120">
                    <template slot-scope="scope">
                        <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                    </template>
                </el-table-column>
                <el-table-column v-if="!disabled && !isQR()" prop="action" align="right" width="70">
                    <template slot-scope="scope">
                        <el-dropdown v-if="scope.row.isAttached" @command="onDeleteDropDownAction(scope.row)">
                            <el-button size="mini">
                                <i class="el-icon-more"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>移除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <ServiceFeeStatementDetailDialog :visible="serviceFeeStatementDetailDialog.visible" :sno="serviceFeeStatementDetailDialog.sno" @close="onServiceFeeStatementDetailDialogClose" />
        <SelectDialog :visible="selectDialog.visible" :isLoading="isLoading" :selected-list="serviceFeeStatementList" :payment="payment" @submit="onSelectDialogSubmit" @close="onSelectDialogClose" />
    </div>
</template>

<script>
import _ from 'lodash';
import StatusLabel from '@/components/dashboard/ServiceFeeStatement/StatusLabel.vue';
import SelectDialog from '@/components/dashboard/ServiceFeeStatement/SelectDialog.vue';
import { serviceTypeList, serviceType9AList, serviceType9BList } from '@/assets/commonData/options';

export default {
    components: { StatusLabel, SelectDialog, ServiceFeeStatementDetailDialog: () => import('@/components/dashboard/ServiceFeeStatement/DetailDialog.vue') },
    props: {
        serviceFeeStatementList: {
            type: Array,
            default: () => [],
        },
        paymentSno: {
            type: Number,
            default: null,
        },
        payment: {
            type: Object,
            default: () => {},
        },
        noHeader: {
            type: Boolean,
            default: false,
        },
        isShowEmptyTable: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            serviceFeeStatementDetailDialog: {
                visible: false,
                sno: null,
            },
            selectDialog: {
                visible: false,
            },
        };
    },
    methods: {
        getTableSummaries({ columns, data }) {
            const sums = [];
            const totalAmount = _.sumBy(data, 'amt');

            columns.forEach((column, index) => {
                if (column.property === 'incomeServiceType') {
                    sums[index] = '總計';
                    return;
                }
                if (column.property === 'cny') {
                    sums[index] = this.form.cny;
                    return;
                }
                if (column.property === 'amt') {
                    sums[index] = totalAmount !== 0 ? Number(totalAmount).toLocaleString('en') : '-';
                }
            });

            return sums;
        },
        getIncomeType(incomeType) {
            const FOUND = _.find(serviceTypeList, ['value', incomeType]);
            return FOUND?.type;
        },
        getServiceType(serviceType) {
            const FOUND = _.find([...serviceType9AList, ...serviceType9BList], ['key', serviceType]);
            return FOUND?.label;
        },

        onAttachServiceFeeStatements() {
            this.selectDialog.visible = true;
        },
        onSelectDialogClose() {
            this.selectDialog.visible = false;
        },
        async onSelectDialogSubmit(val) {
            try {
                this.isLoading = true;

                await this.$api({
                    url: '/ServiceOrder/AttachServiceFeeStatement',
                    method: 'POST',
                    data: {
                        sno: this.paymentSno,
                        serviceFeeStatementSnos: _.map(val, 'sno'),
                    },
                });
                this.selectDialog.visible = false;
                this.$emit('submit');
            } finally {
                this.isLoading = false;
            }
        },

        async onDeleteDropDownAction({ sno }) {
            try {
                await this.$confirm('確定要從請款單移除此勞報單？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                await this.$api({
                    url: '/ServiceOrder/UnattachServiceFeeStatement',
                    method: 'POST',
                    data: { serviceFeeStatementSnos: [sno] },
                });

                this.$emit('submit');
            } catch (e) {
                console.log(e);
            }
        },

        onRowClick({ sno }) {
            this.serviceFeeStatementDetailDialog.visible = true;
            this.serviceFeeStatementDetailDialog.sno = sno;
        },
        onServiceFeeStatementDetailDialogClose() {
            this.serviceFeeStatementDetailDialog.visible = false;
            this.serviceFeeStatementDetailDialog.sno = null;
        },
    },
};
</script>

<style lang="scss" >
.service-fee-statement-info-section {
    .dialog-section-title .service-fee-statement-title-block {
        display: flex;
        justify-content: space-between;
    }
    .is-attached {
        display: inline-block;
        height: 26px;
        line-height: 26px;
        padding: 0 10px;
        border-radius: 8px;
        background-color: #463cb2;
        color: #fff;
        font-size: 9.5pt;
        margin-right: 5px;
    }
    .payment-detail-service-fee-statement-table.el-table {
        .el-table__footer td {
            background-color: #fff;
            font-weight: bold;
        }
        .el-table__footer td:nth-child(-n + 2) {
            border-bottom: 0;
        }
        &::before {
            background-color: transparent !important;
        }
    }
}
</style>
